import { memo, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const RootScrollToBottom = () => {
	const { t } = useTranslation();

	// ref hook
	const scrollToBottomButtonRef = useRef(null);

	// effect hook
	useEffect(() => {
		const scrollToBottomButtonRefCurrent = scrollToBottomButtonRef?.current;
		const scrollToBottomClickHandler = () =>
			window.scrollTo({
				top: document.documentElement.scrollHeight,
				behavior: "smooth",
			});

		scrollToBottomButtonRefCurrent?.addEventListener("click", scrollToBottomClickHandler);

		return () => {
			scrollToBottomButtonRefCurrent?.removeEventListener("click", scrollToBottomClickHandler);
		};
	}, []);

	return (
		<div
			className="root-scroll-to-bottom root-scroll-to-bottom-scrolling d-print-none "
			ref={scrollToBottomButtonRef}>
			<button
				type="button"
				className="btn btn-link btn-sm bg-white text-decoration-none shadow rounded-3 p-2"
				title={t("actions.go_to_bottom")}
				aria-label={t("actions.go_to_bottom")}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="2rem"
					height="2rem"
					fill="currentColor"
					viewBox="0 0 16 16"
					aria-hidden="true">
					<path
						fillRule="evenodd"
						d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
					/>
				</svg>
			</button>
		</div>
	);
};

export default memo(RootScrollToBottom);
